/**
 * Created by Carsten Bühler
 * User: CBuehler on 01.04.2016
 * Copyright: xdot GmbH 2015
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { BusinessObjectLink, DateTimeDisplay, TimeLineItem, TimeLineItemMessageHeader } from 'plugin/base-portlet';
import { getStateStore } from '../stores/StoreFactory';
import StateValueLabel from './StateValueLabel';
import { AppContext, translation } from 'plugin/liferay-widgets-react-web';

const StateStore = getStateStore(AppContext);

class StateValueChangeRecordRenderer extends React.Component {

    constructor(props) {
        super(props);
        this.removeListener = StateStore.addListener(this.onStateStoreChanged.bind(this));

    }

    onStateStoreChanged() {
        if (!StateStore.getGroupRemoteState()._loading && !StateStore.getGroupRemoteState()._error) {
            if (this.removeListener) {
                this.removeListener.remove();
            }
        }

        this.setState({});
    }

    getTranslation(activeState) {
        let title = translation.trans((activeState.className ? (activeState.className + '.') : '') + activeState.propName);

        if (activeState.className === 'ManualBooleanState') {
            title = 'Ereigniszustand';
        }
        return title;
    }

    render() {
        const { changeRecord, userMeta } = this.props;

        const activeState = StateStore.getStateByClassNamePropNameStateId(changeRecord.attachedClassName, changeRecord.changes.propName.newValue, parseInt(changeRecord.changes.stateId.newValue));

        if (!(activeState && activeState.stateTitle && activeState.propName)) {
            console.warn('No ActiveState for StateValueRenderer', changeRecord, activeState);
            return (
                <TimeLineItem userMeta={ userMeta } timestamp={ changeRecord.timestamp }>
                    <div className="d-flex align-items-center h-100">
                        Status wurde nicht gefunden!
                    </div>
                </TimeLineItem>
            );
        }

        const title = this.getTranslation(activeState);

        return (
            <TimeLineItem userMeta={ userMeta } timestamp={ changeRecord.timestamp }>
                <TimeLineItemMessageHeader>
                    <strong>
                        Zustandsänderung für{ ' ' }
                        { translation.trans(changeRecord.attachedClassName) + ' ' }
                        <BusinessObjectLink
                            className={ changeRecord.attachedClassName }
                            classPK={ changeRecord.attachedClassPK }
                        />
                        { ' ' }
                    </strong>
                </TimeLineItemMessageHeader>

                <div className="my-3">
                    Neuer { title } gesetzt.<br/>
                    <StateValueLabel stateName={ title && title } item={ {
                        state: activeState,
                        userMeta,
                        timestamp: changeRecord.timestamp,
                        className: activeState.className,
                        propName: activeState.propName
                    } }/><br/>
                    { changeRecord && changeRecord.changes.userTimestamp && changeRecord.changes.userTimestamp.newValue &&
                        <div>Eingabezeitpunkt: <DateTimeDisplay
                            timestamp={ changeRecord.changes.userTimestamp.newValue }/></div> }
                    Kommentar:{ ' ' + changeRecord.changes.comment.newValue }
                </div>
            </TimeLineItem>

        );
    }
}

StateValueChangeRecordRenderer.propTypes = {
    item: PropTypes.object,
    changeRecord: PropTypes.object,
    userMeta: PropTypes.object
};

export default StateValueChangeRecordRenderer;





// WEBPACK FOOTER //
// ./js/components/StateValueChangeRecordRenderer.jsx